/**
 * Full Screen Image with Text Module
 * Handles scroll-triggered animations for full-width background images
 * Mimics WordPress Waypoints behavior with IntersectionObserver
 */

export default function initFullScreenImageWithText() {
  const modules = document.querySelectorAll('.full-screen-image-with-text');
  
  if (modules.length === 0) return;
  
  modules.forEach((module) => {
    const waypointTop = module.querySelector('.waypoint-top');
    const waypointBottom = module.querySelector('.waypoint-bottom');
    
    if (!waypointTop || !waypointBottom) return;
    
    // Track previous positions to detect scroll direction
    let topPrevY = waypointTop.getBoundingClientRect().top;
    let bottomPrevY = waypointBottom.getBoundingClientRect().top;
    
    // Calculate trigger points (35% and 40% from top of viewport)
    const topTrigger = window.innerHeight * 0.35;
    const bottomTrigger = window.innerHeight * 0.40;
    
    function checkWaypoints() {
      const topRect = waypointTop.getBoundingClientRect();
      const bottomRect = waypointBottom.getBoundingClientRect();
      
      const topY = topRect.top;
      const bottomY = bottomRect.top;
      
      // Detect scroll direction
      const topDirection = topY < topPrevY ? 'down' : 'up';
      const bottomDirection = bottomY < bottomPrevY ? 'down' : 'up';
      
      // Top waypoint logic (crosses 35% line)
      if (topDirection === 'down' && topY <= topTrigger && topPrevY > topTrigger) {
        module.classList.add('active');
      } else if (topDirection === 'up' && topY >= topTrigger && topPrevY < topTrigger) {
        module.classList.remove('active');
      }
      
      // Bottom waypoint logic (crosses 40% line)
      if (bottomDirection === 'down' && bottomY <= bottomTrigger && bottomPrevY > bottomTrigger) {
        module.classList.remove('active');
      } else if (bottomDirection === 'up' && bottomY >= bottomTrigger && bottomPrevY < bottomTrigger) {
        module.classList.add('active');
      }
      
      // Update previous positions
      topPrevY = topY;
      bottomPrevY = bottomY;
    }
    
    // Use scroll event with throttling for better performance
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          checkWaypoints();
          ticking = false;
        });
        ticking = true;
      }
    });
    
    // Initial check
    checkWaypoints();
  });
}
